<template>
    <div id = "app" style="padding: 30px;">
        <h1 class="headerMSG"> 세금계산서 발행 내역 </h1>
        <br/>
        <table class="dataTable">
            <thead class="alignCenter">
                <th>발행년월</th><!-- 2025-08 형태 -->
                <th>수량</th>
                <th>공급가액</th>
                <th>부가세액</th>
                <th>합계금액</th>
            </thead>
            <tbody>
                <template v-if="taxData.length > 0">
                    <tr v-for="(item,index) in taxData" :key="index">
                    <td class="alignCenter">{{ item.year }}-{{ item.month }}</td><!-- 2025-08 형태 -->
                    <td class="alignRight">{{ item.quantity.toLocaleString() }}</td>
                    <td class="alignRight">{{ item.supplyPrice.toLocaleString() }}</td>
                    <td class="alignRight">{{ item.taxPrice.toLocaleString() }}</td>
                    <td class="alignRight">{{ item.salesAmount.toLocaleString() }}</td>
                </tr>
                </template>
                <tr v-else class="alignCenter">
                    <td colspan="5">업로드 된 세금계산서가 없습니다.</td>
                </tr>
            </tbody>
        </table>
        <br/>
        <br/>
        <div class="messageDiv">
            상기와 같이 전자세금계산서를 국세청에 신고하였습니다.<br/>상세 내역은 매월 10일 이후 국세청 사이트 ( <a :href="url" target="_blank">www.esero.go.kr</a>)에서 조회 및 출력이 가능합니다.
        </div>
    </div>
</template>
<script>

    import TaxInvoice from '@/api/TaxInvoice'

    export default {

        data: () => {
            return {
                customerVO: "",
                customerCode : "",
                taxData : [],
                url: "https://www.esero.go.kr"
            }
        },
        
        async created() {
            try {
            console.log('created start!!');

                //taxInvoice 조회
                const submit = { shopId: this.$store.state.customer.customerCode };
                console.log('submit : ',submit);
                
                const res = await TaxInvoice.getTaxInvoice(submit);
                this.taxData = res.data;

                console.log('taxData', this.taxData);
            } catch (e) {
                console.error("에러 발생 : ", e);
            }
        }
        
    }

</script>
<style>
    .headerMSG{
        text-align: center;
        font-size: large;
    }
    .dataTable {
        border-collapse: collapse; /* 겹치는 테두리 제거 */
    }

    /* 테이블 헤더 스타일 */
    .dataTable thead th {
        background-color: #003366; /* 남색 */
        color: #fff;               /* 글자 흰색 */
    }

    .dataTable th,
    .dataTable td {
        border: 1px solid #000; /* 테두리 색상 및 굵기 */
        padding: 8px;           /* 안쪽 여백 */
    }

    .dataTable tr:nth-of-type(even){
        background-color: rgba(166, 166, 197, 0.1);
    }

    /* table th*/
    .alignCenter{
        text-align: center;
    }

    /* table td */
    .alignRight{
        text-align: right;
    }

    .messageDiv{
        border: 2px, solid, black;
        text-align: center;
    }
</style>